


<div class="h-full flex flex-col space-y-6">
  
  @if (!selectedCustomer()) {
    <!-- 1. CLINICAL DASHBOARD HEADERS -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 no-print">
        <div class="bg-white p-5 rounded-2xl shadow-sm border-l-4 border-emerald-500 flex items-center gap-4">
            <div class="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600">
                <i class="fa-solid fa-users text-2xl"></i>
            </div>
            <div>
                <p class="text-xs font-bold text-slate-400 uppercase tracking-wider">คนไข้ทั้งหมด</p>
                <p class="text-2xl font-black text-slate-800">{{ stats().total | number }}</p>
            </div>
        </div>
        <div class="bg-white p-5 rounded-2xl shadow-sm border-l-4 border-blue-500 flex items-center gap-4">
            <div class="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600">
                <i class="fa-solid fa-user-plus text-2xl"></i>
            </div>
            <div>
                <p class="text-xs font-bold text-slate-400 uppercase tracking-wider">ลงทะเบียนวันนี้</p>
                <p class="text-2xl font-black text-slate-800">{{ stats().newToday | number }}</p>
            </div>
        </div>
        <div class="bg-white p-5 rounded-2xl shadow-sm border-l-4 border-rose-500 flex items-center gap-4">
            <div class="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center text-rose-600">
                <i class="fa-solid fa-triangle-exclamation text-2xl"></i>
            </div>
            <div>
                <p class="text-xs font-bold text-slate-400 uppercase tracking-wider">มีประวัติแพ้ยา</p>
                <p class="text-2xl font-black text-slate-800">{{ stats().highRisk | number }}</p>
            </div>
        </div>
    </div>

    <!-- 2. CONTROL BAR -->
    <div class="bg-white p-4 rounded-2xl shadow-sm border border-slate-200 flex flex-col lg:flex-row gap-4 items-center no-print">
        <div class="relative flex-grow w-full">
            <i class="fa-solid fa-magnifying-glass absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"></i>
            <input type="text" [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)" 
                   placeholder="ค้นหาชื่อ, HN, เบอร์โทร หรือเลขบัตรประชาชน..." 
                   class="w-full pl-11 pr-4 py-3 bg-slate-50 border-transparent rounded-xl focus:bg-white focus:ring-2 focus:ring-emerald-500 transition-all text-sm font-medium">
        </div>

        <div class="flex items-center gap-3 w-full lg:w-auto">
            <button (click)="toggleAllergyFilter()" 
                    [class]="filterAllergiesOnly() ? 'bg-rose-50 border-rose-200 text-rose-700' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'"
                    class="flex-1 lg:flex-none px-4 py-2.5 border rounded-xl text-sm font-bold transition-all flex items-center justify-center gap-2">
                <i class="fa-solid fa-filter"></i> <span>แพ้ยา</span>
            </button>
            <div class="h-8 w-px bg-slate-200 hidden lg:block"></div>
            <div class="flex bg-slate-100 p-1 rounded-xl">
                <button (click)="viewMode.set('reception')" [class]="viewMode() === 'reception' ? 'bg-white text-emerald-600 shadow-sm' : 'text-slate-400'" class="p-2 rounded-lg transition-all"><i class="fa-solid fa-grip"></i></button>
                <button (click)="viewMode.set('table')" [class]="viewMode() === 'table' ? 'bg-white text-emerald-600 shadow-sm' : 'text-slate-400'" class="p-2 rounded-lg transition-all"><i class="fa-solid fa-list-ul"></i></button>
            </div>
            
            <!-- Export Button (Visible Only for Clinic Owners) -->
            @if(canExport()) {
                <button (click)="openExportModal()" class="bg-white border border-green-600 text-green-700 hover:bg-green-50 px-4 py-2.5 rounded-xl font-bold transition-all shadow-sm flex items-center justify-center gap-2 whitespace-nowrap disabled:opacity-50">
                     <i class="fa-solid fa-file-export"></i> <span>Export Data</span>
                </button>
            }

            <button (click)="openAddModal()" class="bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-2.5 rounded-xl font-bold transition-all shadow-lg flex items-center justify-center gap-2 whitespace-nowrap">
                <i class="fa-solid fa-user-plus"></i> <span>ลงทะเบียนใหม่</span>
            </button>
        </div>
    </div>

    <!-- 3. MAIN DATA AREA -->
    <div class="flex-grow flex flex-col overflow-hidden">
        @if (loadingState() === 'loading') {
            <div class="flex-grow flex flex-col items-center justify-center py-20 text-slate-400">
                <i class="fa-solid fa-circle-notch animate-spin text-4xl mb-4 text-emerald-500"></i>
                <p class="font-bold">กำลังดึงข้อมูลเวชระเบียน...</p>
            </div>
        } @else {
            @if (viewMode() === 'table') {
                <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col">
                    <div class="overflow-x-auto">
                        <table class="w-full text-left border-collapse">
                            <thead>
                                <tr class="bg-slate-50 border-b border-slate-200">
                                    <th (click)="setSort('hn')" class="px-6 py-4 text-[10px] font-black text-slate-500 uppercase tracking-widest cursor-pointer hover:bg-slate-100 transition-colors">
                                        HN <i class="fa-solid ml-1" [class]="sortKey() === 'hn' ? (sortDirection() === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort opacity-20'"></i>
                                    </th>
                                    <th (click)="setSort('fullName')" class="px-6 py-4 text-[10px] font-black text-slate-500 uppercase tracking-widest cursor-pointer hover:bg-slate-100 transition-colors">
                                        ชื่อ-นามสกุล (Patient) <i class="fa-solid ml-1" [class]="sortKey() === 'fullName' ? (sortDirection() === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort opacity-20'"></i>
                                    </th>
                                    <th class="px-6 py-4 text-[10px] font-black text-slate-500 uppercase tracking-widest">สถานะทางการแพทย์</th>
                                    <th (click)="setSort('createdAt')" class="px-6 py-4 text-[10px] font-black text-slate-500 uppercase tracking-widest cursor-pointer hover:bg-slate-100 transition-colors">
                                        วันที่ลงทะเบียน <i class="fa-solid ml-1" [class]="sortKey() === 'createdAt' ? (sortDirection() === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort opacity-20'"></i>
                                    </th>
                                    <th class="px-6 py-4 text-right"></th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-slate-100">
                                @for (c of paginatedCustomers(); track c.id) {
                                    <tr class="hover:bg-slate-50/80 transition-colors group">
                                        <td class="px-6 py-4 font-mono font-bold text-emerald-700">{{ c.hn || '-' }}</td>
                                        <td class="px-6 py-4">
                                            <div class="flex items-center gap-3">
                                                <div class="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center font-bold text-slate-500 overflow-hidden">
                                                    @if(c.profile_image_url){ <img [src]="c.profile_image_url" class="w-full h-full object-cover"> }
                                                    @else { {{ c.fullName.charAt(0) }} }
                                                </div>
                                                <div>
                                                    <p class="font-bold text-slate-800 leading-tight">{{ c.fullName }}</p>
                                                    <p class="text-[10px] text-slate-400 font-mono">{{ c.phone || 'ไม่ระบุเบอร์' }}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="px-6 py-4">
                                            <div class="flex gap-1">
                                                @if(c.allergies) { 
                                                    <span class="px-2 py-0.5 rounded-full text-[10px] font-black bg-rose-100 text-rose-700 border border-rose-200 animate-pulse">แพ้ยา</span> 
                                                }
                                                @if(c.underlyingDisease) {
                                                    <span class="px-2 py-0.5 rounded-full text-[10px] font-black bg-orange-100 text-orange-700 border border-orange-200">โรคประจำตัว</span>
                                                }
                                                @if(!c.allergies && !c.underlyingDisease) {
                                                    <span class="px-2 py-0.5 rounded-full text-[10px] font-black bg-slate-100 text-slate-400 border border-slate-200 uppercase">Normal</span>
                                                }
                                            </div>
                                        </td>
                                        <td class="px-6 py-4 text-xs text-slate-500">{{ c.createdAt | date:'dd MMM yyyy' }}</td>
                                        <td class="px-6 py-4 text-right">
                                            <div class="flex justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                                <button (click)="viewCustomerDetails(c)" class="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" title="ดูรายละเอียด"><i class="fa-solid fa-eye"></i></button>
                                                <button (click)="openEditModal(c)" class="p-2 text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors"><i class="fa-solid fa-pen-to-square"></i></button>
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    
                    <!-- 4. PAGINATION FOOTER -->
                    <div class="p-4 bg-slate-50 border-t border-slate-200 flex flex-col sm:flex-row justify-between items-center gap-4">
                        <p class="text-xs font-bold text-slate-500 uppercase tracking-widest">พบคนไข้ทั้งหมด {{ processedCustomers().length }} รายการ</p>
                        @if(totalPages() > 1) {
                            <div class="flex items-center gap-2">
                                <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1" class="w-8 h-8 rounded-lg border border-slate-300 flex items-center justify-center hover:bg-white disabled:opacity-30 transition-all"><i class="fa-solid fa-chevron-left text-xs"></i></button>
                                <div class="px-4 text-sm font-black text-slate-700">{{ currentPage() }} / {{ totalPages() }}</div>
                                <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages()" class="w-8 h-8 rounded-lg border border-slate-300 flex items-center justify-center hover:bg-white disabled:opacity-30 transition-all"><i class="fa-solid fa-chevron-right text-xs"></i></button>
                            </div>
                        }
                    </div>
                </div>
            } @else {
                <!-- RECEPTION (CARD) VIEW -->
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 overflow-y-auto pb-8">
                    @for (c of paginatedCustomers(); track c.id) {
                        <div (click)="viewCustomerDetails(c)" class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200 hover:shadow-xl hover:-translate-y-1 transition-all cursor-pointer group relative">
                            <div class="flex justify-between items-start mb-4">
                                <div class="w-14 h-14 rounded-2xl bg-slate-100 overflow-hidden border-2 border-white shadow-sm">
                                    @if(c.profile_image_url){ <img [src]="c.profile_image_url" class="w-full h-full object-cover"> }
                                    @else { <div class="w-full h-full flex items-center justify-center font-black text-xl text-slate-400">{{ c.fullName.charAt(0) }}</div> }
                                </div>
                                <span class="px-2 py-1 bg-emerald-50 text-emerald-600 font-mono font-bold text-[10px] rounded-lg border border-emerald-100">{{ c.hn || 'No HN' }}</span>
                            </div>
                            <h3 class="font-bold text-slate-800 group-hover:text-emerald-600 transition-colors truncate">{{ c.fullName }}</h3>
                            <p class="text-xs text-slate-500 mt-1 flex items-center gap-1"><i class="fa-solid fa-phone text-[10px]"></i> {{ c.phone || '-' }}</p>
                            
                            <div class="mt-4 flex flex-wrap gap-1">
                                @if(c.allergies) { <span class="w-2 h-2 rounded-full bg-rose-500" title="แพ้ยา"></span> }
                                @if(c.underlyingDisease) { <span class="w-2 h-2 rounded-full bg-orange-500" title="โรคประจำตัว"></span> }
                            </div>
                        </div>
                    }
                </div>
            }
        }
    </div>

  } @else {
    <!-- 4. PATIENT DETAIL VIEW (EMR DASHBOARD) -->
    @let c = selectedCustomer();
    <div class="animate-fade-in-fast h-full flex flex-col gap-6 overflow-hidden">
        <!-- Dashboard Header -->
        <div class="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4">
            <div class="flex items-center gap-4">
                <button (click)="backToList()" class="w-10 h-10 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-all">
                    <i class="fa-solid fa-arrow-left"></i>
                </button>
                <div class="w-16 h-16 rounded-2xl bg-slate-100 overflow-hidden shadow-inner border">
                     @if(c?.profile_image_url){ <img [src]="c?.profile_image_url" class="w-full h-full object-cover"> }
                     @else { <div class="w-full h-full flex items-center justify-center font-black text-2xl text-slate-400">{{ c?.fullName?.charAt(0) }}</div> }
                </div>
                <div>
                    <h2 class="text-2xl font-black text-slate-800 flex items-center gap-2">
                        {{ c?.fullName }}
                        @if(c?.allergies) { <span class="px-2 py-0.5 bg-rose-100 text-rose-700 text-[10px] font-black rounded-lg border border-rose-200">HIGH RISK</span> }
                    </h2>
                    <p class="text-sm font-bold text-slate-400 flex items-center gap-2">
                        <span class="bg-slate-100 px-2 rounded text-emerald-600 font-mono">HN: {{ c?.hn }}</span>
                        <span>•</span>
                        <span>อายุ {{ selectedCustomerAge() }} ปี</span>
                    </p>
                </div>
            </div>
            <div class="flex gap-2">
                <button (click)="openEditModal(c!)" class="bg-slate-800 text-white px-5 py-2.5 rounded-xl font-bold flex items-center gap-2 hover:bg-slate-700 transition-all">
                    <i class="fa-solid fa-pen-to-square"></i> แก้ไขข้อมูล
                </button>
            </div>
        </div>

        <div class="flex-grow grid grid-cols-1 lg:grid-cols-4 gap-6 overflow-hidden min-h-0">
            <!-- Left Sidebar: Patient Stats -->
            <div class="lg:col-span-1 space-y-6">
                <!-- Vitals Card -->
                <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200">
                    <h3 class="text-xs font-black text-slate-400 uppercase tracking-widest mb-4">สัญญาณชีพ (Vital Signs)</h3>
                    <div class="grid grid-cols-2 gap-4">
                        <div class="p-3 bg-slate-50 rounded-xl border border-slate-100">
                            <p class="text-[10px] font-bold text-slate-500 uppercase">อุณหภูมิ</p>
                            <p class="text-lg font-black text-rose-600">{{ c?.temperature_c || '--' }} <span class="text-xs text-slate-400 font-normal">°C</span></p>
                        </div>
                        <div class="p-3 bg-slate-50 rounded-xl border border-slate-100">
                            <p class="text-[10px] font-bold text-slate-500 uppercase">ชีพจร</p>
                            <p class="text-lg font-black text-blue-600">{{ c?.pulse_rate || '--' }} <span class="text-xs text-slate-400 font-normal">bpm</span></p>
                        </div>
                        <div class="col-span-2 p-3 bg-slate-50 rounded-xl border border-slate-100">
                            <p class="text-[10px] font-bold text-slate-500 uppercase">ความดัน</p>
                            <p class="text-lg font-black text-slate-800">{{ c?.blood_pressure || '-- / --' }} <span class="text-xs text-slate-400 font-normal">mmHg</span></p>
                        </div>
                    </div>
                    <div class="mt-4 pt-4 border-t border-slate-100 flex justify-between items-center text-xs text-slate-400 font-bold">
                        <span>น้ำหนัก {{ c?.weight_kg || '-' }} kg</span>
                        <span>ส่วนสูง {{ c?.height_cm || '-' }} cm</span>
                    </div>
                </div>

                <!-- Contact Card -->
                <div class="bg-white p-5 rounded-2xl shadow-sm border border-slate-200">
                    <h3 class="text-xs font-black text-slate-400 uppercase tracking-widest mb-4">ช่องทางติดต่อ</h3>
                    <div class="space-y-3">
                        <div class="flex items-center gap-3">
                            <div class="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center"><i class="fa-solid fa-phone"></i></div>
                            <span class="text-sm font-bold text-slate-700">{{ c?.phone || 'ไม่ระบุ' }}</span>
                        </div>
                        <div class="flex items-start gap-3">
                            <div class="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shrink-0"><i class="fa-solid fa-location-dot"></i></div>
                            <span class="text-xs text-slate-500 leading-relaxed">{{ c?.address || 'ไม่มีข้อมูลที่อยู่' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Main Content Area -->
            <div class="lg:col-span-3 bg-white rounded-2xl shadow-sm border border-slate-200 flex flex-col overflow-hidden">
                <!-- Inner Tabs -->
                <div class="flex border-b border-slate-100">
                    <button (click)="setActiveTab('medical')" [class]="activeDetailTab() === 'medical' ? 'border-emerald-500 text-emerald-700 bg-emerald-50/30 font-bold' : 'border-transparent text-slate-400'" class="flex-1 py-4 text-sm border-b-2 transition-all">ประวัติการแพทย์</button>
                    <button (click)="setActiveTab('identity')" [class]="activeDetailTab() === 'identity' ? 'border-emerald-500 text-emerald-700 bg-emerald-50/30 font-bold' : 'border-transparent text-slate-400'" class="flex-1 py-4 text-sm border-b-2 transition-all">หลักฐานตัวตน (KYC)</button>
                    <button (click)="setActiveTab('history')" [class]="activeDetailTab() === 'history' ? 'border-emerald-500 text-emerald-700 bg-emerald-50/30 font-bold' : 'border-transparent text-slate-400'" class="flex-1 py-4 text-sm border-b-2 transition-all">ประวัติใบสั่งยา</button>
                </div>

                <div class="flex-grow p-6 overflow-y-auto custom-scrollbar">
                    @switch (activeDetailTab()) {
                        @case ('medical') {
                            <div class="space-y-8 animate-fade-in-fast">
                                <!-- Allergy High-Alert -->
                                <div [class]="c?.allergies ? 'bg-rose-50 border-rose-200 text-rose-800' : 'bg-slate-50 border-slate-100 text-slate-500'" class="p-6 rounded-2xl border-2">
                                    <h4 class="font-black text-sm uppercase tracking-wider mb-2 flex items-center gap-2">
                                        <i class="fa-solid fa-triangle-exclamation"></i> ประวัติแพ้ยา (Allergies)
                                    </h4>
                                    <p class="text-xl font-bold">{{ c?.allergies || 'ไม่มีประวัติแพ้ยา (No Known Allergies)' }}</p>
                                </div>

                                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                                    <div>
                                        <h4 class="font-black text-xs text-slate-400 uppercase mb-4">โรคประจำตัว (Underlying Disease)</h4>
                                        <div class="p-4 bg-orange-50/50 rounded-xl border border-orange-100">
                                            <p class="text-sm font-bold text-slate-700">{{ c?.underlyingDisease || '-' }}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <h4 class="font-black text-xs text-slate-400 uppercase mb-4">หมายเหตุเวชระเบียน</h4>
                                        <div class="p-4 bg-slate-50 rounded-xl border border-slate-100 min-h-[80px]">
                                            <p class="text-sm text-slate-600">{{ c?.medicalHistory || '-' }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        @case ('identity') {
                            <div class="space-y-6 animate-fade-in-fast">
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <h4 class="font-black text-xs text-slate-400 uppercase mb-4">สำเนาบัตรประชาชน</h4>
                                        @if(c?.idCardUrl) {
                                            <div class="rounded-2xl border border-slate-200 overflow-hidden shadow-lg group relative">
                                                <img [src]="c?.idCardUrl" alt="ID Card Copy" class="w-full object-cover">
                                                <div class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                                    <a [href]="c?.idCardUrl" target="_blank" class="bg-white px-4 py-2 rounded-lg font-bold text-xs">ขยายรูปภาพ</a>
                                                </div>
                                            </div>
                                        } @else {
                                            <div class="aspect-video bg-slate-50 rounded-2xl border-2 border-dashed border-slate-200 flex flex-col items-center justify-center text-slate-400">
                                                <i class="fa-solid fa-id-card text-4xl mb-2"></i>
                                                <p class="text-xs font-bold">ไม่พบรูปภาพสำเนาบัตร</p>
                                            </div>
                                        }
                                    </div>
                                    <div>
                                        <h4 class="font-black text-xs text-slate-400 uppercase mb-4">ข้อมูล KYC พื้นฐาน</h4>
                                        <div class="space-y-4">
                                            <div class="flex justify-between border-b pb-2">
                                                <span class="text-slate-400 text-xs">เลขบัตรประชาชน</span>
                                                <span class="font-mono font-bold">{{ c?.citizenId || '-' }}</span>
                                            </div>
                                            <div class="flex justify-between border-b pb-2">
                                                <span class="text-slate-400 text-xs">วันเกิด</span>
                                                <span class="font-bold">{{ c?.birthDate | date:'dd MMMM yyyy' }}</span>
                                            </div>
                                            <div class="flex justify-between border-b pb-2">
                                                <span class="text-slate-400 text-xs">บัตรสมาชิก (UID)</span>
                                                <span class="font-mono font-bold">{{ c?.card_uid || '-' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        @case ('history') {
                            <div class="animate-fade-in-fast h-full flex flex-col">
                                @if (isLoadingHistory()) {
                                    <div class="text-center py-20 text-slate-400">
                                        <i class="fa-solid fa-circle-notch animate-spin text-4xl mb-4 text-emerald-500"></i>
                                        <p class="font-bold uppercase tracking-widest text-xs">กำลังดึงประวัติการรักษา...</p>
                                    </div>
                                } @else {
                                    <div class="overflow-x-auto">
                                        <table class="w-full text-left text-sm border-collapse">
                                            <thead>
                                                <tr class="bg-slate-50 text-[10px] font-black text-slate-500 uppercase tracking-widest">
                                                    <th class="px-4 py-3 border-b">วันที่ (Date)</th>
                                                    <th class="px-4 py-3 border-b">แพทย์ (Provider)</th>
                                                    <th class="px-4 py-3 border-b">ผลวินิจฉัย (Diagnosis)</th>
                                                    <th class="px-4 py-3 border-b">จำนวนที่สั่ง (Qty)</th>
                                                    <th class="px-4 py-3 border-b text-right"></th>
                                                </tr>
                                            </thead>
                                            <tbody class="divide-y divide-slate-100">
                                                @for (h of customerHistory(); track h.id) {
                                                    <tr class="hover:bg-slate-50/50 transition-colors">
                                                        <td class="px-4 py-4 whitespace-nowrap">
                                                            <div class="font-bold text-slate-800">{{ h.createdAt | date:'dd/MM/yyyy' }}</div>
                                                            <div class="text-[10px] text-slate-400 font-mono">{{ h.createdAt | date:'HH:mm' }}</div>
                                                        </td>
                                                        <td class="px-4 py-4">
                                                            <div class="text-xs font-bold text-slate-700">{{ h.doctorName || 'Doctor on Duty' }}</div>
                                                        </td>
                                                        <td class="px-4 py-4">
                                                            <div class="text-xs text-slate-600 max-w-xs truncate">{{ h.approvedItems?.symptoms || '-' }}</div>
                                                        </td>
                                                        <td class="px-4 py-4 font-mono font-bold text-emerald-700">
                                                            {{ h.approvedItems?.totalAmount | number:'1.1-2' }} <span class="text-[10px] font-normal text-slate-400">{{ h.approvedItems?.dosageUnit }}</span>
                                                        </td>
                                                        <td class="px-4 py-4 text-right">
                                                            <div class="flex justify-end gap-2">
                                                                <span class="px-2 py-0.5 rounded text-[10px] font-black uppercase border"
                                                                      [class]="h.status === 'USED' ? 'bg-slate-100 text-slate-500 border-slate-200' : 'bg-green-100 text-green-700 border-green-200'">
                                                                    {{ h.status }}
                                                                </span>
                                                                <button (click)="reprintPrescription(h.id)" title="พิมพ์ใบรับรองซ้ำ" class="text-blue-500 hover:text-blue-700 transition-colors">
                                                                    <i class="fa-solid fa-print"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                } @empty {
                                                    <tr>
                                                        <td colspan="5" class="px-4 py-20 text-center text-slate-400">
                                                            <i class="fa-solid fa-folder-open text-4xl mb-4 opacity-30"></i>
                                                            <p class="font-bold">ไม่พบประวัติการสั่งจ่ายยาของผู้ป่วยรายนี้</p>
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
  }

</div>

<app-customer-form-modal [isOpen]="isModalOpen()" [customer]="editingCustomer()" (closeModal)="handleCloseModal()" (saveCustomer)="handleSaveCustomer($event)"></app-customer-form-modal>
<app-export-modal [isOpen]="isExportModalOpen()" [isProcessing]="isExporting()" (closeModal)="isExportModalOpen.set(false)" (confirmExport)="handleExportConfirm($event)"></app-export-modal>
